import { useEffect } from "react";
import { NavLink } from "react-router-dom";

const Modal = ({ setModalOpen, setAnimating, animating, isOpen }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("body-overflow-hidden");
    } else {
      document.body.classList.remove("body-overflow-hidden");
    }

    return () => {
      document.body.classList.remove("body-overflow-hidden");
    };
  }, [isOpen]);

  const handleClose = () => {
    setAnimating(false);
    setTimeout(() => {
      setModalOpen(false);
    }, 500);
  };

  return (
    <div className={`modal ${animating ? "open-modal" : "close-modal"}`}>
      <button className="close-btn" onClick={handleClose}>
        X
      </button>

      <ul>
        <li onClick={handleClose}>
          <NavLink exact to="/" activeClassName="active">
            Home
          </NavLink>
        </li>
        <li onClick={handleClose}>
          <NavLink to="/projects" activeClassName="active">
            Projects
          </NavLink>
        </li>
        <li onClick={handleClose}>
          <NavLink to="/skills" activeClassName="active">
            Skills
          </NavLink>
        </li>

        <li onClick={handleClose}>
          <NavLink to="/about" activeClassName="active">
            About
          </NavLink>
        </li>
        <li onClick={handleClose}>
          <NavLink to="/contact" activeClassName="active">
            Contact
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Modal;
